/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type TourReelsGenerateReelMutationVariables = {
    tourId: string;
};
export type TourReelsGenerateReelMutationResponse = {
    readonly tourGenerateReel: {
        readonly reel: {
            readonly id: string;
        };
    };
};
export type TourReelsGenerateReelMutation = {
    readonly response: TourReelsGenerateReelMutationResponse;
    readonly variables: TourReelsGenerateReelMutationVariables;
};



/*
mutation TourReelsGenerateReelMutation(
  $tourId: ID!
) {
  tourGenerateReel(input: {tourId: $tourId}) {
    reel {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tourId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "tourId",
            "variableName": "tourId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "TourGenerateReelPayload",
    "kind": "LinkedField",
    "name": "tourGenerateReel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Reel",
        "kind": "LinkedField",
        "name": "reel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TourReelsGenerateReelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TourReelsGenerateReelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ffb47e28510e731b4e2c21bdb4d967e3",
    "id": null,
    "metadata": {},
    "name": "TourReelsGenerateReelMutation",
    "operationKind": "mutation",
    "text": "mutation TourReelsGenerateReelMutation(\n  $tourId: ID!\n) {\n  tourGenerateReel(input: {tourId: $tourId}) {\n    reel {\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '59cc5c1e777554743e62dbf95e2606b5';
export default node;
